/* Cortisol LP — purchase box (sections/cortisol-buy.liquid) */
(function () {
  function initBuyBox(form) {
    if (form.dataset.clpReady) return;
    form.dataset.clpReady = 'true';

    var planInput = form.querySelector('[data-clp-selling-plan]');
    var idInput = form.querySelector('input[name="id"]');
    var qtyWrap = form.querySelector('[data-clp-qty]');
    var qtySelect = form.querySelector('select[name="quantity"]');
    var options = form.querySelectorAll('.clp-option');
    var button = form.querySelector('[data-clp-add]');
    var error = form.querySelector('[data-clp-error]');
    var label = button ? button.innerHTML : '';

    function select(input) {
      options.forEach(function (option) {
        option.classList.toggle('is-selected', option.contains(input));
      });
      var plan = input.getAttribute('data-selling-plan');
      planInput.value = plan || '';
      planInput.disabled = !plan;
      // A quarterly option adds its own product, always one at a time
      var variantId = input.getAttribute('data-variant-id');
      if (idInput && variantId) idInput.value = variantId;
      var isQuarterly = input.hasAttribute('data-quarterly');
      if (qtySelect) {
        if (isQuarterly) qtySelect.value = '1';
        qtySelect.disabled = isQuarterly;
      }
      if (qtyWrap) qtyWrap.hidden = isQuarterly;
    }

    function showError(message) {
      if (!error) return;
      error.textContent = message || 'Something went wrong. Please try again.';
      error.hidden = false;
    }

    function setLoading(loading) {
      if (!button) return;
      button.disabled = loading;
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
    }

    form.querySelectorAll('.clp-option__input').forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) select(input);
      });
      if (input.checked) select(input);
    });

    // Errors raised by the theme cart (e.g. stock / subscription limits).
    if (button) {
      button.addEventListener('theme:product:add-error', function (event) {
        var response = event.detail && event.detail.response;
        showError(response && (response.description || response.message));
      });
    }

    // Fallback when the theme cart drawer is not available: add via AJAX, then go to the cart.
    function addDirectly() {
      setLoading(true);
      fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: new FormData(form),
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data.status) {
            setLoading(false);
            showError(data.description || data.message);
            return;
          }
          window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
        })
        .catch(function () {
          setLoading(false);
          button.innerHTML = label;
          showError();
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!button || button.disabled) return;
      if (error) error.hidden = true;

      // Hand over to the theme cart (drawer + upsells), same as the PDP buttons.
      var addEvent = new CustomEvent('theme:cart:add', {
        detail: { button: button },
        cancelable: true,
      });
      document.dispatchEvent(addEvent);

      if (!addEvent.defaultPrevented) addDirectly();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('form[data-clp-buy]').forEach(initBuyBox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Hero CTA: smooth-scroll to the buy box, clearing the fixed header.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-clp-scroll]');
    if (!link) return;
    var target = document.getElementById('clp-buy');
    if (!target) return;
    event.preventDefault();

    var header = document.querySelector('.theme__header');
    var offset = header ? Math.max(header.getBoundingClientRect().bottom, 0) + 20 : 20;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.pageYOffset - offset,
      behavior: reduce ? 'auto' : 'smooth',
    });
    target.focus({ preventScroll: true });
  });
})();
